(() => {
  const endpoint='https://technast-free-attachments.technast-aion.workers.dev/events';
  const allowed=new Set(['contact_clicked','contact_view','form_started','submit_clicked','submit_attempt','message_success','message_error','validation_error','upload_requested','login_required','login_started','login_returned','upload_complete','upload_failed','upload_blocks_send']);
  const key='tn_contact_journey_v1';let journey;
  try {journey=JSON.parse(sessionStorage.getItem(key)||'null');}catch{}
  if(!journey||!/^[a-f0-9]{32}$/.test(journey.id)||journey.until<Date.now())journey={id:Array.from(crypto.getRandomValues(new Uint8Array(16)),b=>b.toString(16).padStart(2,'0')).join(''),until:Date.now()+1800000,sent:[],login:false};
  const save=()=>{try{sessionStorage.setItem(key,JSON.stringify(journey));}catch{}};
  const consent=()=>{
    const p=window.Shopify?.customerPrivacy;
    return navigator.globalPrivacyControl!==true && (!p || p.analyticsProcessingAllowed());
  };
  const pending=new Set();
  function track(event){
    if(!allowed.has(event))return;
    if(event==='login_started'){journey.login=true;save();}
    if(journey.sent.includes(event))return;
    if(!consent()){pending.add(event);return;}
    journey.sent.push(event);save();
    fetch(endpoint,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify({session:journey.id,event}),keepalive:true,credentials:'omit',referrerPolicy:'no-referrer'}).then(r=>{
      if(!r.ok){journey.sent=journey.sent.filter(x=>x!==event);save();}
    }).catch(()=>{journey.sent=journey.sent.filter(x=>x!==event);save();});
  }
  window.TECHNASTContactTrack=track;
  document.addEventListener('visitorConsentCollected',()=>{for(const e of pending)track(e);pending.clear();});
  document.addEventListener('click',e=>{
    const a=e.target.closest?.('a[href]');if(!a)return;
    try{const u=new URL(a.href,location.href);if(u.origin===location.origin&&u.pathname==='/pages/contact-us')track('contact_clicked');}catch{}
  });
  const root=document.getElementById('technast-drop-upload'),form=root?.closest('form');
  if(!form)return;
  track('contact_view');
  if(journey.login&&root.dataset.customer){track('login_returned');journey.login=false;save();}
  if(root.dataset.submitted==='true')track('message_success');
  if(root.dataset.formErrors==='true')track('message_error');
  form.addEventListener('input',()=>track('form_started'),{once:true});
  form.addEventListener('invalid',()=>track('validation_error'),true);
  form.addEventListener('click',e=>{if(e.target.closest?.('button[type="submit"]'))track('submit_clicked');});
  form.addEventListener('submit',e=>{if(!e.defaultPrevented)track('submit_attempt');});
})();
